import { render, staticRenderFns } from "./professionNews.vue?vue&type=template&id=36a2edeb&scoped=true&"
import script from "./professionNews.vue?vue&type=script&lang=js&"
export * from "./professionNews.vue?vue&type=script&lang=js&"
import style0 from "./professionNews.vue?vue&type=style&index=0&id=36a2edeb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2edeb",
  null
  
)

export default component.exports